<div class="title">Create Permission</div>
<br>
<arb-message class="error" [message$]="message$"></arb-message>
<br>
<br>
<div class="form">
    <div class="UserList">
        <h4><label>Users</label></h4>
        <mat-select [(ngModel)]="selectedUser">
            <mat-option value="SelectUser">Select User</mat-option>
            <mat-option value="{{user.userId}}" *ngFor="let user of permissionUser | async">{{user.userFullName}}</mat-option>
        </mat-select>
    </div>
    <div class="FAQToggle">
        <h4><label>FAQ Edit</label></h4>
        <mat-slide-toggle color="primary" [(ngModel)]="FAQEdit"></mat-slide-toggle>
    </div>
    <div class="SupportToggle">
        <h4><label>Support Edit</label></h4>
        <mat-slide-toggle color="primary" [(ngModel)]="SupportEdit"></mat-slide-toggle>
    </div>
</div>
<br>
<!-- <div class="error" *ngIf="error">Please select user</div>
<div class="error" *ngIf="errorServer">Oops, something went wrong</div> -->
<br>
<div class="actions">
  <button mat-raised-button color="primary" class="AddBtn" (click)="addPermission()">Add</button>
  <button mat-flat-button class="close-button" mat-dialog-close (click)="close(false)">Close</button>
</div>